export default __webpack_public_path__ + "static/media/tutorials.16f794bc.png";